package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_flow.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_flow.CreditCardsInfoEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px

@Composable
fun PaymentMethods(
    creditCards:List<String?>?,
    windowSizeMode: WindowSizeModeEnum,
    updateCreditCards:(List<String?>)->Unit,
)
{
    val data = creditCards?.toMutableList()
    val chunk=if (windowSizeMode==WindowSizeModeEnum.PHONE) 1 else 2
    Column(
        modifier = Modifier
            .width(
                Dimen.mediumEditTextWidth.plus(Dimen.mediumEditTextWidth)
                    .plus(Dimen.largePadding)
            )
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
    )
    {
        MediumContentTitle(
            title = Strings.current().paymentMethods,
            marginBottom = Dimen.mediumPadding,
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            CreditCardsInfoEnum.entries
                .chunked(chunk).forEachIndexed {  rowIndex, rowItems ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                )
                {
                    rowItems.forEachIndexed{colIndex, creditCardInfo ->
                        val index = rowIndex * 2 + colIndex
                        CustomEditText(
                            modifier = Modifier,
                            width =Dimen.mediumEditTextWidth,
                            marginRight = if (colIndex==0) Dimen.largePadding
                                else 0.px,
                            label = creditCardInfo.titleShown,
                            value =creditCards?.getOrNull(index) ?: "",
                            isRequired = false,
                            hint ="",
                            fillMaxWidth =windowSizeMode==WindowSizeModeEnum.PHONE,
                            onFocusIn = {},
                            onFocusOut = {
                                data?.set(index = index, element = it)
                                updateCreditCards(
                                    data?.toList()?: listOf()
                                )
                            },
                            onInputChange = {it, validation ->

                            },
                        )


                    }
                }
            }
        }



    }
}